'use client'

import { useRef } from 'react'
import { useWidth } from '../../../hooks/use-width.ts'
import { createContext } from '../../../utils/context.ts'

const useSidebarLayout = () => {
  const { widthClassName } = useWidth({ maxWidth: 'screen-2xl', width: 'full' })

  const mainScrollRef = useRef<HTMLDivElement>(null)

  const setMainScrollRef = (ref: HTMLDivElement | null) => {
    mainScrollRef.current = ref
  }

  return {
    clampWidthClassName: widthClassName,
    mainScrollRef,
    setMainScrollRef,
  }
}

const [SidebarLayoutProvider, useSidebarLayoutContext] = createContext<
  ReturnType<typeof useSidebarLayout>
>({ name: 'SidebarLayoutContext' })

export { SidebarLayoutProvider, useSidebarLayoutContext, useSidebarLayout }
